module.exports = __webpack_public_path__ + "img/methodology_d.cf8e0582.png";